export default __webpack_public_path__ + "static/media/submitCharity.dbb55c0b.webp";